export default __webpack_public_path__ + "static/media/3480921fceff09cf69e5570c526cd46c.png";